import React from "react";
import { Check, ArrowRight, LayoutDashboard, Mail, House as HomeIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StarterPackageHero() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  const benefits = ["Custom modern website design", "12 months hosting & domain included", "Up to 3 professional pages"];
  return <section id="starter-package-hero" ref={sectionRef} className="dark bg-background text-foreground relative overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[400px] h-[400px] bg-primary/5 rounded-full blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className={`flex flex-col items-start space-y-8 transition-all duration-700 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <Badge variant="default" className="inline-flex items-center justify-center border w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-primary/90 bg-primary/10 text-primary border-primary/20 px-4 py-1.5 text-sm font-semibold rounded-full backdrop-blur-sm ![margin:35px_0px_32px_0px] dark:aria-invalid:ring-destructive/40 hover:bg-primary/20">
              $995 + GST
            </Badge>

            <div className="space-y-4">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.1]">
                Starter Website <span className="text-primary">Package</span>
              </h1>
              <p className="text-lg text-muted-foreground max-w-xl leading-relaxed">
                Perfect for small businesses and trades looking to establish a professional online presence quickly and affordably.
              </p>
            </div>

            <ul className="space-y-4 w-full max-w-md">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center text-primary">
                    <Check className="w-4 h-4" />
                  </div>
                  <span className="text-foreground/90 font-medium">{benefit}</span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 pt-4 w-full sm:w-auto">
              <Button asChild size="lg" className="rounded-full text-base px-8 h-12 shadow-[0_0_20px_-5px_var(--color-primary)]">
                <Link to="/contact">
                  Start My Website
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-full text-base px-8 h-12 border-white/10 hover:bg-white/5">
                
              </Button>
            </div>
          </div>

          {}
          <div className={`relative h-[400px] lg:h-[500px] w-full flex items-center justify-center perspective-[2000px] transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {}
            <div className="relative w-full max-w-[500px] h-[300px] transform-style-3d rotate-y-[-12deg] rotate-x-[5deg]">
              
              {}
              <div className="absolute top-[-40px] right-[-20px] w-[240px] h-[320px] bg-card border border-white/5 rounded-xl shadow-2xl transform translate-z-[-100px] translate-x-[80px] opacity-60 scale-90 transition-transform hover:translate-z-[-50px] duration-500">
                <div className="p-4 border-b border-white/5 flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-red-500/50" />
                  <div className="w-2 h-2 rounded-full bg-yellow-500/50" />
                  <div className="w-2 h-2 rounded-full bg-green-500/50" />
                  <div className="ml-auto text-[10px] text-muted-foreground font-mono">Contact</div>
                </div>
                <div className="p-6 space-y-4">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary mb-4">
                    <Mail className="w-5 h-5" />
                  </div>
                  <div className="h-2 w-3/4 bg-white/10 rounded" />
                  <div className="h-2 w-1/2 bg-white/10 rounded" />
                  <div className="h-20 w-full bg-white/5 rounded mt-4 border border-white/5" />
                  <div className="h-8 w-full bg-primary/20 rounded mt-2" />
                </div>
              </div>

              {}
              <div className="absolute top-[-20px] left-[-20px] w-[240px] h-[320px] bg-card border border-white/5 rounded-xl shadow-2xl transform translate-z-[-50px] translate-x-[-60px] opacity-80 scale-95 transition-transform hover:translate-z-[0px] duration-500">
                <div className="p-4 border-b border-white/5 flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-red-500/50" />
                  <div className="w-2 h-2 rounded-full bg-yellow-500/50" />
                  <div className="w-2 h-2 rounded-full bg-green-500/50" />
                  <div className="ml-auto text-[10px] text-muted-foreground font-mono">Services</div>
                </div>
                <div className="p-6 grid grid-cols-2 gap-3">
                  <div className="col-span-2 h-24 bg-white/5 rounded-lg border border-white/5 mb-2 flex items-center justify-center">
                    <LayoutDashboard className="w-8 h-8 text-muted-foreground/50" />
                  </div>
                  <div className="h-20 bg-white/5 rounded-lg border border-white/5" />
                  <div className="h-20 bg-white/5 rounded-lg border border-white/5" />
                </div>
              </div>

              {}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[280px] h-[380px] bg-card border border-white/10 rounded-xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.5)] transform translate-z-[50px] transition-transform hover:translate-z-[80px] duration-500 ring-1 ring-white/5">
                <div className="p-4 border-b border-white/5 flex items-center gap-2 bg-white/5">
                  <div className="w-2.5 h-2.5 rounded-full bg-red-500" />
                  <div className="w-2.5 h-2.5 rounded-full bg-yellow-500" />
                  <div className="w-2.5 h-2.5 rounded-full bg-green-500" />
                  <div className="ml-auto px-2 py-0.5 rounded-full bg-black/20 text-[10px] text-muted-foreground font-mono">websiteshop.com.au</div>
                </div>
                <div className="relative overflow-hidden h-[calc(100%-53px)]">
                  {}
                  <div className="h-32 bg-gradient-to-br from-background to-secondary p-4 flex flex-col justify-center items-center text-center space-y-2 border-b border-white/5">
                    <div className="w-8 h-8 rounded bg-primary/20 flex items-center justify-center text-primary mb-1">
                      <HomeIcon className="w-4 h-4" />
                    </div>
                    <div className="h-2 w-3/4 bg-white/20 rounded" />
                    <div className="h-1.5 w-1/2 bg-white/10 rounded" />
                    <div className="mt-2 px-3 py-1 bg-primary text-[8px] font-bold text-primary-foreground rounded-full">
                      GET STARTED
                    </div>
                  </div>
                  {}
                  <div className="p-4 space-y-3">
                    <div className="flex gap-3">
                      <div className="w-1/3 h-16 bg-white/5 rounded border border-white/5" />
                      <div className="w-2/3 space-y-2">
                        <div className="h-2 w-full bg-white/10 rounded" />
                        <div className="h-2 w-5/6 bg-white/10 rounded" />
                        <div className="h-2 w-4/6 bg-white/10 rounded" />
                      </div>
                    </div>
                    <div className="grid grid-cols-3 gap-2 mt-4">
                      <div className="h-12 bg-white/5 rounded border border-white/5" />
                      <div className="h-12 bg-white/5 rounded border border-white/5" />
                      <div className="h-12 bg-white/5 rounded border border-white/5" />
                    </div>
                  </div>
                </div>
                
                {}
                <div className="absolute -inset-0.5 bg-gradient-to-br from-primary/30 to-transparent opacity-20 blur-lg -z-10 rounded-xl" />
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>;
}